import Axios from "axios";
import Auth from "@/services/Auth";
import Environment from "@/environment";
import Community from "@/services/Community";

function User() {}

User.prototype.get = async function (id) {
  return await Axios.get("/users/" + id);
};

User.prototype.update = async function (user, id) {
  return await Axios.put("/users/" + id, user);
};

User.prototype.create = async function (user, headers = {}) {
  return await Axios.post("/users", user, { headers });
};

User.prototype.me = async function () {
  return await Axios.get(
    Environment.TendaEduAPI + "/user/me?_community=" + Community.community,
    {
      headers: {
        Authorization: "Bearer " + Auth.currentToken,
      },
    },
  );
};

User.prototype.exists = async function (alias, headers = {}) {
  return await Axios.get(`/users/exists/${alias}`, { headers });
};

User.prototype.copy = async function (alias, body = {}, headers = {}) {
  return await Axios.post(`/users/copy/${alias}`, body, { headers });
};

User.prototype.search = async function (params = {}) {
  return await Axios.get("/users/search", { params });
};

// Expose Singleton
export default new User();



// WEBPACK FOOTER //
// ./src/services/User.js